import { Maybe } from "@figurepos/fgr-lib-business-logic/lib/common/types"
import { createGraphQLRequest } from "../../../../api/utils/httpRequest"
import type {
    HooSettingsResponse,
    OnlineOrderingSettingsResponse,
    OnlineOrderingSettingsSaveRequest,
} from "../../../../graphql/types"
import { ResponseData } from "../../../../graphql/types"
import { GQLData } from "../../../../graphql/utils"

export const fetchHooSettings = (
    headers: Record<string, any>,
    locationId: string,
    terminalId: string
): Promise<Maybe<HooSettingsResponse>> =>
    createGraphQLRequest({
        headers: headers,
        body: {
            query: `
                query hooSettings($locationId: String, $terminalId: String) {
                    settings(locationId: $locationId, terminalId: $terminalId) {
                        hoo {
                            deliveryHoo {
                                isActive
                                timeSpans
                            }
                            pickupHoo {
                                isActive
                                timeSpans
                            }                           
                        }
                    }    
                }
            `,
            operationName: "hooSettings",
            variables: {
                locationId: locationId,
                terminalId: terminalId,
            },
        },
    }).then(response => {
        if (response && response.data && response.data.settings && response.data.settings.hoo) {
            return response.data.settings.hoo
        }

        return null
    })

export type MibSettingsQueryRes = GQLData<"onlineOrderingSettings", OnlineOrderingSettingsResponse>
export const mibSettingsQuery = `
    query onlineOrderingSettings($locationId: String!, $terminalId: String!) {
        onlineOrderingSettings(locationId: $locationId, terminalId: $terminalId) {
            logoUrl
            iconUrl
            desktopImageUrl
        }    
    }
`

export const saveMibSettingsMutation = (
    headers: Record<string, any>,
    data: OnlineOrderingSettingsSaveRequest
): Promise<ResponseData> =>
    createGraphQLRequest({
        headers: headers,
        body: {
            query: `
                 mutation onlineOrderingSettingsSave($data: OnlineOrderingSettingsSaveRequest!) {
                    onlineOrderingSettingsSave(data: $data) {
                        success
                    }
                }
            `,
            operationName: "onlineOrderingSettingsSave",
            variables: {
                data: data,
            },
        },
    }).then(response => {
        const data = response?.data?.onlineOrderingSettingsSave
        if (data) {
            return data
        } else {
            throw new Error("onlineOrderingSettingsSave error")
        }
    })
